/**
 * 工具
 * Filename: tools.js
 * Author: GaoYu
 * Time: 2020/8/3 15:52
 */
/**
 * 秒数格式化 如 600 =》 10:00
 * @param value
 */
export function formatSeconds (value) {
  let theTime = parseInt(value)// 秒
  if (!theTime || theTime < 0) {
    return ''
  }
  let min = 0 // 分
  let sec = 0 // 秒
  if (theTime > 60) {
    min = parseInt(theTime / 60)
    sec = parseInt(theTime % 60)
  } else {
    sec = theTime
  }
  if (min < 10) {
    min = '0' + min
  }
  if (sec < 10) {
    sec = '0' + sec
  }
  return min + ':' + sec
}

/**
 * 数组去重
 * @param arr
 * @returns {[]}
 */
export function uniqueArray (arr) {
  let result = []
  let hash = {}
  for (var i = 0, elem; (elem = arr[i]) != null; i++) {
    if (!hash[elem]) {
      result.push(elem)
      hash[elem] = true
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/tools.js